import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	openInANewTab: {
		id: 'command-palette-common.common.new-tab-hint-message.open-in-a-new-tab',
		defaultMessage: 'Open in a new tab',
		description:
			'Message to be displayed in the command palette footer when the user can open the command palette in a new tab',
	},
	ctrlLozenge: {
		id: 'command-palette-common.common.new-tab-hint-message.windows-ctrl',
		defaultMessage: 'Ctrl',
		description:
			'Windows ctrl key to be displayed as key modifer, paired with enter key to open in a new tab',
	},
});
